import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CorteDiarioModel } from '../corte-diario.models';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { Chart } from 'angular-highcharts';
import { GraphGridSwitchComponent } from '../graph-grid-switch/graph-grid-switch.component';
import Enumerable from 'linq';
import { ModalGestionesComponent } from '../modal-gestiones/modal-gestiones.component';
import { ModalGestionesGenericoComponent } from '../modal-gestiones-generico/modal-gestiones-generico.component';

@Component({
  selector: 'modal-graph-by-analisis-sitio-destino',
  templateUrl: './modal-graph-by-analisis-sitio-destino.component.html',
  styleUrls: ['./modal-graph-by-analisis-sitio-destino.component.css'],
})
export class ModalGraphByAnalisisSitioDestinoComponent implements OnInit {
  @ViewChild('graphCalorInfo', { static: false })
  graphCalorInfo: GraphGridSwitchComponent;
  private filtroSubject = new Subject<{ event: Event; descripcion: string }>();
  public listGestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>;
  public chart: Chart;
  public switchUsdGestion: boolean = true;
  public mostrarFiltros: boolean = false;
  public switchTablaOrGraph: boolean = true;
  public listCostosFactura: Array<CorteDiarioModel.CostosFactura> = [];
  public maxTiempoProceso = 0;
  public minTiempoProceso = 0;
  // Propiedades para gráficos
  public scatterData: number[] = [];
  public lineGraphDataTons: number[] = [];
  public lineGraphData: number[] = [];
  public BoxPlotData: number[][] = [];
  public BoxPlotDataDelta: number[][] = [];
  public series: any[] = [];
  public categories: string[] = [
    'Origen',
    'Transito 1',
    'Frontera',
    'Transito 2',
    'Destino',
  ];
  public filtroActivo: string = 'sku'; // Filtro predeterminado
  public graphDelta: boolean = false;
  public switch1: boolean = false;
  public costostitle: string = 'Toneladas';
  public unlock: boolean = false;

  public listCostosLog: Array<CorteDiarioModel.CostosLogisticos> = [];
  public groupByCategory: CorteDiarioModel.ListCategories[] = [];
  public groupByCategoryCL: CorteDiarioModel.ListCategories[] = [];

  public AlllistGestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>;
  public PlantillaSelected: CorteDiarioModel.PlantillasIndex;
  public listrutasXUsuario: Array<CorteDiarioModel.RutasByUsuario> = [];
  public listHistoricoBytemplate: Array<CorteDiarioModel.HistoricoTemplate> =
    [];
  public VolumenTotalGestiones: number = 0;
  //listado de sitios Origen
  public listOrigen: Array<CorteDiarioModel.NombresXRutasXSegmentacion> = [];

  //listado de sitios Destino
  public listDestino: Array<CorteDiarioModel.NombresXRutasXSegmentacion> = [];
  //variables para conteos de segmentos origen
  contadorOrigenOrigen: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorOrigenTransitoUno: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorOrigenFrontera: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorOrigenTransitoDos: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorOrigenDestino: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};

  //variables para conteos de segmentos Destino
  contadorDestinoOrigen: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorDestinoTransitoUno: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorDestinoFrontera: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorDestinoTransitoDos: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};
  contadorDestinoDestino: {
    [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[];
  } = {};

  //variables para conteos de segmentos PaisDestino
  contadorPaisDestinoOrigen: {
    [key: string]: CorteDiarioModel.ContadorGestiones;
  } = {};
  contadorPaisDestinoTransitoUno: {
    [key: string]: CorteDiarioModel.ContadorGestiones;
  } = {};
  contadorPaisDestinoFrontera: {
    [key: string]: CorteDiarioModel.ContadorGestiones;
  } = {};
  contadorPaisDestinoTransitoDos: {
    [key: string]: CorteDiarioModel.ContadorGestiones;
  } = {};
  contadorPaisDestinoDestino: {
    [key: string]: CorteDiarioModel.ContadorGestiones;
  } = {};

  //varoables para conteos de las categorias SKU
  public contadorCategoriasOrigen: {
    [key: string]: CorteDiarioModel.ContadorSku;
  } = {};
  public contadorCategoriasTransitoUno: {
    [key: string]: CorteDiarioModel.ContadorSku;
  } = {};
  public contadorCategoriasFrontera: {
    [key: string]: CorteDiarioModel.ContadorSku;
  } = {};
  public contadorCategoriasTransitoDos: {
    [key: string]: CorteDiarioModel.ContadorSku;
  } = {};
  public contadorCategoriasDestino: {
    [key: string]: CorteDiarioModel.ContadorSku;
  } = {};
  public ocultarPaisDestino: boolean = false;
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipo: string;
      usuarioId: string;
      gestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>;
      PlantillaSelected: CorteDiarioModel.PlantillasIndex;
      chart: Chart;
      paisSitio: string;
      ocultarPaisDestino: boolean;
    }
  ) {
    // Configurar el debounce para el filtro
    this.filtroSubject
      .pipe(
        debounceTime(300), // Esperar 300 ms después de la última tecla presionada
        distinctUntilChanged() // Evitar llamadas duplicadas si el valor no cambia
      )
      .subscribe(({ event, descripcion }) => {});
  }

  ngOnInit(): void {
    this.listGestiones = this.data.gestiones;
    this.ocultarPaisDestino = this.data.ocultarPaisDestino;

    // Calcular min y max de TiempoProceso para mostrar en los inputs (solo visual)
    this.minTiempoProceso = parseFloat(
      Enumerable.from(this.listGestiones)
        .min((s) => s.TiempoProceso)
        .toFixed(2)
    );
    this.maxTiempoProceso = parseFloat(
      Enumerable.from(this.listGestiones)
        .max((s) => s.TiempoProceso)
        .toFixed(2)
    );

    // Inicializar gráficos con las gestiones del sitio
    this.GenerateDataFacturacion(this.listGestiones);
    this.EventGenerateGRaph(this.listGestiones);
    this.GenerateDataOrigenFiltro(this.listGestiones);
    this.GenerateDataDestinoFiltro(this.listGestiones);
    console.log('this.data', this.data);
  }

  EventGenerateGRaph(
    event: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>
  ) {
    this.scatterData = []; // Tiempos meta
    this.lineGraphDataTons = [];

    // Arrays para boxplot (todos los valores en días)
    let arrayBoxPlot: Array<number[]> = [];
    let arrayBoxPlotDelta: Array<number[]> = [];

    // 1. ORIGEN
    let arrayOrigen = [0, 0, 0, 0, 0];
    let arrayOrigenDelta = [0, 0, 0, 0, 0];

    this.lineGraphDataTons = []; // Limpiar array de toneladas

    // 1. CÁLCULO DE TONELADAS (parte nueva)
    // Origen
    let cantidadTons = parseFloat(
      Enumerable.from(event)
        .where((s) => s.Segmentacion.Origen?.SitioActual == true)
        .selectMany((s) => s.CostosFacturacion)
        .sum((s) => s.TotalPesoToneladas ?? 0) // Usamos 0 si es null/undefined
        .toFixed(2)
    );
    this.lineGraphDataTons.push(cantidadTons);

    // Transito1
    cantidadTons = parseFloat(
      Enumerable.from(event)
        .where((s) =>
          s.Segmentacion.TransitoUno.some(
            (t) => t.SitioActual == true || t?.SegmentoActual == true
          )
        )
        .selectMany((s) => s.CostosFacturacion)
        .sum((s) => s.TotalPesoToneladas ?? 0)
        .toFixed(2)
    );
    this.lineGraphDataTons.push(cantidadTons);

    // Frontera
    cantidadTons = parseFloat(
      Enumerable.from(event)
        .where((s) =>
          s.Segmentacion.Frontera?.some((t) => t.SitioActual == true)
        )
        .selectMany((s) => s.CostosFacturacion)
        .sum((s) => s.TotalPesoToneladas ?? 0)
        .toFixed(2)
    );
    this.lineGraphDataTons.push(cantidadTons);

    // Transito2
    cantidadTons = parseFloat(
      Enumerable.from(event)
        .where((s) =>
          s.Segmentacion.TransitoDos.some(
            (t) => t.SitioActual == true || t?.SegmentoActual == true
          )
        )
        .selectMany((s) => s.CostosFacturacion)
        .sum((s) => s.TotalPesoToneladas ?? 0)
        .toFixed(2)
    );
    this.lineGraphDataTons.push(cantidadTons);

    // Destino
    cantidadTons = parseFloat(
      Enumerable.from(event)
        .where((s) =>
          s.Segmentacion?.Destino?.some((t) => t.SitioActual == true)
        )
        .selectMany((s) => s.CostosFacturacion)
        .sum((s) => s.TotalPesoToneladas ?? 0)
        .toFixed(2)
    );
    this.lineGraphDataTons.push(cantidadTons);

    let origenArray = Enumerable.from(event)
      .select((s) => s.Segmentacion.Origen)
      .where((s) => s?.SitioActual == true)
      .toArray()
      .filter((item) => item !== null && item !== undefined);

    if (origenArray.length > 0) {
      // Tiempo meta (días)
      let tiempoMetaDiasOrigen = parseFloat(
        (
          Enumerable.from(origenArray).sum((s) => s.TiempoMetaEnHoras) / 24
        ).toFixed(2)
      );
      this.scatterData.push(
        parseFloat((tiempoMetaDiasOrigen / origenArray.length).toFixed(2))
      );

      // Tiempos proceso (días)
      let arraySortOrigen = Enumerable.from(origenArray)
        .select((s) => s.TiempoDias)
        .toArray()
        .sort((a, b) => a - b);

      // Deltas (convertidos a días)
      let arraySortOrigenDelta = Enumerable.from(origenArray)
        .select((s) => s.TiempoDelta / 24)
        .toArray()
        .sort((a, b) => a - b);

      // Calcular quartiles tiempo proceso
      arrayOrigen[0] = parseFloat(
        Enumerable.from(origenArray)
          .min((s) => s.TiempoDias)
          .toFixed(2)
      );
      arrayOrigen[1] = this.GenerateQuartil(arraySortOrigen, 1);
      arrayOrigen[2] = this.GenerateQuartil(arraySortOrigen, 2);
      arrayOrigen[3] = this.GenerateQuartil(arraySortOrigen, 3);
      arrayOrigen[4] = parseFloat(
        Enumerable.from(origenArray)
          .max((s) => s.TiempoDias)
          .toFixed(2)
      );

      // Calcular quartiles delta (días)
      arrayOrigenDelta[0] = parseFloat(
        (Enumerable.from(origenArray).min((s) => s.TiempoDelta) / 24).toFixed(2)
      );
      arrayOrigenDelta[1] = this.GenerateQuartil(arraySortOrigenDelta, 1);
      arrayOrigenDelta[2] = this.GenerateQuartil(arraySortOrigenDelta, 2);
      arrayOrigenDelta[3] = this.GenerateQuartil(arraySortOrigenDelta, 3);
      arrayOrigenDelta[4] = parseFloat(
        (Enumerable.from(origenArray).max((s) => s.TiempoDelta) / 24).toFixed(2)
      );
    } else {
      this.scatterData.push(0);
    }

    arrayBoxPlot.push(arrayOrigen);
    arrayBoxPlotDelta.push(arrayOrigenDelta);

    // 2. TRANSITO 1
    let arrayTransito1 = [0, 0, 0, 0, 0];
    let arrayTransito1Delta = [0, 0, 0, 0, 0];

    let transito1Array = Enumerable.from(event)
      .selectMany((s) => s.Segmentacion.TransitoUno)
      .where((s) => s?.SitioActual == true || s?.SegmentoActual == true)
      .toArray();

    if (transito1Array.length > 0) {
      // Tiempo meta (días)
      let tiempoMetaDiasT1 = parseFloat(
        (
          Enumerable.from(transito1Array).sum((s) => s.TiempoMetaEnHoras) / 24
        ).toFixed(2)
      );
      this.scatterData.push(
        parseFloat((tiempoMetaDiasT1 / transito1Array.length).toFixed(2))
      );

      // Tiempos proceso (días)
      let arraySortT1 = Enumerable.from(transito1Array)
        .select((s) => s.TiempoDias)
        .toArray()
        .sort((a, b) => a - b);

      // Deltas (convertidos a días)
      let arraySortT1Delta = Enumerable.from(transito1Array)
        .select((s) => s.TiempoDelta / 24)
        .toArray()
        .sort((a, b) => a - b);

      // Calcular quartiles tiempo proceso
      arrayTransito1[0] = parseFloat(
        Enumerable.from(transito1Array)
          .min((s) => s.TiempoDias)
          .toFixed(2)
      );
      arrayTransito1[1] = this.GenerateQuartil(arraySortT1, 1);
      arrayTransito1[2] = this.GenerateQuartil(arraySortT1, 2);
      arrayTransito1[3] = this.GenerateQuartil(arraySortT1, 3);
      arrayTransito1[4] = parseFloat(
        Enumerable.from(transito1Array)
          .max((s) => s.TiempoDias)
          .toFixed(2)
      );

      // Calcular quartiles delta (días)
      arrayTransito1Delta[0] = parseFloat(
        (
          Enumerable.from(transito1Array).min((s) => s.TiempoDelta) / 24
        ).toFixed(2)
      );
      arrayTransito1Delta[1] = this.GenerateQuartil(arraySortT1Delta, 1);
      arrayTransito1Delta[2] = this.GenerateQuartil(arraySortT1Delta, 2);
      arrayTransito1Delta[3] = this.GenerateQuartil(arraySortT1Delta, 3);
      arrayTransito1Delta[4] = parseFloat(
        (
          Enumerable.from(transito1Array).max((s) => s.TiempoDelta) / 24
        ).toFixed(2)
      );
    } else {
      this.scatterData.push(0);
    }

    arrayBoxPlot.push(arrayTransito1);
    arrayBoxPlotDelta.push(arrayTransito1Delta);

    // 3. FRONTERA
    let arrayFrontera = [0, 0, 0, 0, 0];
    let arrayFronteraDelta = [0, 0, 0, 0, 0];

    let fronteraArray = Enumerable.from(event)
      .selectMany((s) => s.Segmentacion.Frontera)
      .where((s) => s?.SitioActual == true)
      .toArray();

    if (fronteraArray.length > 0) {
      // Tiempo meta (días)
      let tiempoMetaDiasF = parseFloat(
        (
          Enumerable.from(fronteraArray).sum((s) => s.TiempoMetaEnHoras) / 24
        ).toFixed(2)
      );
      this.scatterData.push(
        parseFloat((tiempoMetaDiasF / fronteraArray.length).toFixed(2))
      );

      // Tiempos proceso (días)
      let arraySortFrontera = Enumerable.from(fronteraArray)
        .select((s) => s.TiempoDias)
        .toArray()
        .sort((a, b) => a - b);

      // Deltas (convertidos a días)
      let arraySortFronteraDelta = Enumerable.from(fronteraArray)
        .select((s) => s.TiempoDelta / 24)
        .toArray()
        .sort((a, b) => a - b);

      // Calcular quartiles tiempo proceso
      arrayFrontera[0] = parseFloat(
        Enumerable.from(fronteraArray)
          .min((s) => s.TiempoDias)
          .toFixed(2)
      );
      arrayFrontera[1] = this.GenerateQuartil(arraySortFrontera, 1);
      arrayFrontera[2] = this.GenerateQuartil(arraySortFrontera, 2);
      arrayFrontera[3] = this.GenerateQuartil(arraySortFrontera, 3);
      arrayFrontera[4] = parseFloat(
        Enumerable.from(fronteraArray)
          .max((s) => s.TiempoDias)
          .toFixed(2)
      );

      // Calcular quartiles delta (días)
      arrayFronteraDelta[0] = parseFloat(
        (Enumerable.from(fronteraArray).min((s) => s.TiempoDelta) / 24).toFixed(
          2
        )
      );
      arrayFronteraDelta[1] = this.GenerateQuartil(arraySortFronteraDelta, 1);
      arrayFronteraDelta[2] = this.GenerateQuartil(arraySortFronteraDelta, 2);
      arrayFronteraDelta[3] = this.GenerateQuartil(arraySortFronteraDelta, 3);
      arrayFronteraDelta[4] = parseFloat(
        (Enumerable.from(fronteraArray).max((s) => s.TiempoDelta) / 24).toFixed(
          2
        )
      );
    } else {
      this.scatterData.push(0);
    }

    arrayBoxPlot.push(arrayFrontera);
    arrayBoxPlotDelta.push(arrayFronteraDelta);

    // 4. TRANSITO 2
    let arrayTransito2 = [0, 0, 0, 0, 0];
    let arrayTransito2Delta = [0, 0, 0, 0, 0];

    let transito2Array = Enumerable.from(event)
      .selectMany((s) => s.Segmentacion.TransitoDos)
      .where((s) => s?.SitioActual == true || s?.SegmentoActual == true)
      .toArray();

    if (transito2Array.length > 0) {
      // Tiempo meta (días)
      let tiempoMetaDiasT2 = parseFloat(
        (
          Enumerable.from(transito2Array).sum((s) => s.TiempoMetaEnHoras) / 24
        ).toFixed(2)
      );
      this.scatterData.push(
        parseFloat((tiempoMetaDiasT2 / transito2Array.length).toFixed(2))
      );

      // Tiempos proceso (días)
      let arraySortT2 = Enumerable.from(transito2Array)
        .select((s) => s.TiempoDias)
        .toArray()
        .sort((a, b) => a - b);

      // Deltas (convertidos a días)
      let arraySortT2Delta = Enumerable.from(transito2Array)
        .select((s) => s.TiempoDelta / 24)
        .toArray()
        .sort((a, b) => a - b);

      // Calcular quartiles tiempo proceso
      arrayTransito2[0] = parseFloat(
        Enumerable.from(transito2Array)
          .min((s) => s.TiempoDias)
          .toFixed(2)
      );
      arrayTransito2[1] = this.GenerateQuartil(arraySortT2, 1);
      arrayTransito2[2] = this.GenerateQuartil(arraySortT2, 2);
      arrayTransito2[3] = this.GenerateQuartil(arraySortT2, 3);
      arrayTransito2[4] = parseFloat(
        Enumerable.from(transito2Array)
          .max((s) => s.TiempoDias)
          .toFixed(2)
      );

      // Calcular quartiles delta (días)
      arrayTransito2Delta[0] = parseFloat(
        (
          Enumerable.from(transito2Array).min((s) => s.TiempoDelta) / 24
        ).toFixed(2)
      );
      arrayTransito2Delta[1] = this.GenerateQuartil(arraySortT2Delta, 1);
      arrayTransito2Delta[2] = this.GenerateQuartil(arraySortT2Delta, 2);
      arrayTransito2Delta[3] = this.GenerateQuartil(arraySortT2Delta, 3);
      arrayTransito2Delta[4] = parseFloat(
        (
          Enumerable.from(transito2Array).max((s) => s.TiempoDelta) / 24
        ).toFixed(2)
      );
    } else {
      this.scatterData.push(0);
    }

    arrayBoxPlot.push(arrayTransito2);
    arrayBoxPlotDelta.push(arrayTransito2Delta);

    // 5. DESTINO
    let arrayDestino = [0, 0, 0, 0, 0];
    let arrayDestinoDelta = [0, 0, 0, 0, 0];

    let destinosArray = Enumerable.from(event)
      .selectMany((s) => s.Segmentacion.Destino)
      .where((s) => s?.SitioActual == true)
      .toArray();

    if (destinosArray.length > 0) {
      // Tiempo meta (días)
      let tiempoMetaDiasDestino = parseFloat(
        (
          Enumerable.from(destinosArray).sum((s) => s.TiempoMetaEnHoras) / 24
        ).toFixed(2)
      );
      this.scatterData.push(
        parseFloat((tiempoMetaDiasDestino / destinosArray.length).toFixed(2))
      );

      // Tiempos proceso (días)
      let arraySortDestino = Enumerable.from(destinosArray)
        .select((s) => s.TiempoDias)
        .toArray()
        .sort((a, b) => a - b);

      // Deltas (convertidos a días)
      let arraySortDestinoDelta = Enumerable.from(destinosArray)
        .select((s) => s.TiempoDelta / 24)
        .toArray()
        .sort((a, b) => a - b);

      // Calcular quartiles tiempo proceso
      arrayDestino[0] = parseFloat(
        Enumerable.from(destinosArray)
          .min((s) => s.TiempoDias)
          .toFixed(2)
      );
      arrayDestino[1] = this.GenerateQuartil(arraySortDestino, 1);
      arrayDestino[2] = this.GenerateQuartil(arraySortDestino, 2);
      arrayDestino[3] = this.GenerateQuartil(arraySortDestino, 3);
      arrayDestino[4] = parseFloat(
        Enumerable.from(destinosArray)
          .max((s) => s.TiempoDias)
          .toFixed(2)
      );

      // Calcular quartiles delta (días)
      arrayDestinoDelta[0] = parseFloat(
        (Enumerable.from(destinosArray).min((s) => s.TiempoDelta) / 24).toFixed(
          2
        )
      );
      arrayDestinoDelta[1] = this.GenerateQuartil(arraySortDestinoDelta, 1);
      arrayDestinoDelta[2] = this.GenerateQuartil(arraySortDestinoDelta, 2);
      arrayDestinoDelta[3] = this.GenerateQuartil(arraySortDestinoDelta, 3);
      arrayDestinoDelta[4] = parseFloat(
        (Enumerable.from(destinosArray).max((s) => s.TiempoDelta) / 24).toFixed(
          2
        )
      );
    } else {
      this.scatterData.push(0);
    }

    arrayBoxPlot.push(arrayDestino);
    arrayBoxPlotDelta.push(arrayDestinoDelta);

    // Asignar los datos finales
    this.BoxPlotData = arrayBoxPlot;
    this.BoxPlotDataDelta = arrayBoxPlotDelta;

    // Costos y toneladas (sin cambios)
    if (this.listCostosFactura.length > 0) {
      let origenSum = parseFloat(this.listCostosFactura[0].Origen.toFixed(2));
      let TransitoUnoSum = parseFloat(
        this.listCostosFactura[0].TransitoUno.toFixed(2)
      );
      let FronteraSum = parseFloat(
        this.listCostosFactura[0].Frontera.toFixed(2)
      );
      let TransitoDosSum = parseFloat(
        this.listCostosFactura[0].TransitoDos.toFixed(2)
      );
      let DestinoSum = parseFloat(this.listCostosFactura[0].Destino.toFixed(2));

      this.lineGraphData = [
        origenSum,
        TransitoUnoSum,
        FronteraSum,
        TransitoDosSum,
        DestinoSum,
      ];
    }

    this.initChart();
  }

  GenerateQuartil(arraySort: number[], tipoQuartil: number) {
    let QOrigenIndex =
      tipoQuartil == 1
        ? (arraySort.length + 1) / 4
        : tipoQuartil == 2
        ? (arraySort.length + 1) / 2
        : ((arraySort.length + 1) * 3) / 4;

    let QOrigenVal = Number.isInteger(QOrigenIndex); //verificar si es decimal o entero
    let Quartil = QOrigenVal
      ? arraySort[QOrigenIndex - 1] //es entero
      : (arraySort[Math.floor(QOrigenIndex) - 1] +
          arraySort[Math.floor(QOrigenIndex)]) /
        2; //elijo el anterior y siguiente y divido
    //: (arraySort[Math.floor(QOrigenIndex) ] + arraySort[Math.floor(QOrigenIndex) + 1]) / 2//elijo el anterior y siguiente y divido

    return Number.isNaN(Quartil) || Quartil == undefined
      ? 0
      : parseFloat(Quartil.toFixed(2));
  }

  initChart() {
    const boxplotData = this.BoxPlotData;
    const boxplotDeltaData = this.BoxPlotDataDelta;
    this.series = [];

    if (!this.graphDelta) {
      this.series.push(
        // 1. Serie de Boxplot (Tiempo Proceso)
        {
          name: 'Tiempo Proceso (días)',
          type: 'boxplot',
          data: this.BoxPlotData,
          pointWidth: 30,
          tooltip: {
            headerFormat: '<em>{point.key}</em><br/>',
            pointFormat:
              '◉ Máximo: {point.high} días<br/>' +
              '⬦ Q3: {point.q3} días<br/>' +
              '■ Mediana: {point.median} días<br/>' +
              '⬦ Q1: {point.q1} días<br/>' +
              '◉ Mínimo: {point.low} días',
          },
        },
        // 2. Serie Dinámica (Costos/Toneladas controlado por el switch)
        {
          name: this.costostitle, // El título ya cambia con el switch
          type: 'line',
          data: !this.switch1 ? this.lineGraphDataTons : this.lineGraphData,
          yAxis: 1,
          tooltip: {
            valuePrefix: !this.switch1 ? '' : '$',
            valueSuffix: !this.switch1 ? ' ton' : '',
            valueDecimals: 2,
          },
        },
        // 3. Serie de Tiempo Meta
        {
          name: 'Tiempo Meta',
          type: 'scatter',
          data: this.scatterData,
          marker: {
            symbol: 'circle',
            radius: 4,
            fillColor: 'blue',
          },
          tooltip: {
            pointFormat: 'Punto más alto: {point.y}',
          },
        }
      );
    } else {
      // Versión Delta (sin cambios)
      this.series.push({
        name: 'Tiempo Proceso (días)',
        type: 'boxplot',
        data: this.BoxPlotDataDelta,
        pointWidth: 30,
        tooltip: {
          headerFormat: '<em>{point.key}</em><br/>',
          pointFormat:
            '◉ Máximo: {point.high} días<br/>' +
            '⬦ Q3: {point.q3} días<br/>' +
            '■ Mediana: {point.median} días<br/>' +
            '⬦ Q1: {point.q1} días<br/>' +
            '◉ Mínimo: {point.low} días',
        },
      });
    }

    // Configuración del chart (sin cambios)
    this.chart = new Chart({
      chart: {
        height: 350,
        zoomType: 'y',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: this.categories,
      },
      yAxis: [
        {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        {
          title: {
            text: '',
          },
          opposite: true,
          labels: {
            format: '{value}',
          },
        },
      ],
      legend: {
        enabled: true,
        align: 'left',
        verticalAlign: 'top',
        layout: 'vertical',
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        boxplot: {
          fillColor: '#0072b2',
          zones: [
            {
              value: 1,
              fillColor: '#0072b2',
            },
            {
              value: 2,
              fillColor: '#0072b2',
            },
            {
              value: 3,
              fillColor: '#1fa187',
            },
            {
              value: 4,
              fillColor: '#0072b2',
            },
            {
              value: 5,
              fillColor: '#0072b2',
            },
          ],
        },
        scatter: {
          tooltip: {
            headerFormat:
              '<span style="font-size:12px; font-weight: bold">Tiempo Meta:</span><br/><div> ' +
              ' <hr/>',
            pointFormatter: function () {
              var data: any = this.y;
              return '<b>' + data + '</b>' + '<br/>';
            },
            footerFormat: '</div>',
          },
        },
      },
      series: this.series,
    });
  }

  EventGraphDelta() {
    this.graphDelta = !this.graphDelta;
    this.initChart();
  }

  EventChangeUsdVol() {
    this.switch1 = !this.switch1;
    this.costostitle = this.switch1 ? 'Costos USD' : 'Toneladas';
    this.initChart();
  }

  EventChangeTableOrGraph() {
    //this.switchTablaOrGraph = !this.switchTablaOrGraph;
    //this.listCostosFactura[0].Expandible = this.listCostosFactura[0].Expandible == false ? true : this.listCostosFactura[0].Expandible;
    if (!this.switchTablaOrGraph) {
      setTimeout(() => {
        this.graphCalorInfo.listGestiones = this.listGestiones;
        this.graphCalorInfo.ngGenerateSectionInfoGraph();
      }, 1000);
    }
    // Mostrar u ocultar los filtros según el estado de la tabla
    if (this.switchTablaOrGraph) {
      this.mostrarFiltros = !this.mostrarFiltros;
    } else if (!this.switchTablaOrGraph) {
      this.mostrarFiltros = false;
    }
  }

  MostrarCostosLogisticos() {}

  EventModalGestiones(tipo: string) {
    let gestionesFiltradas = this.listGestiones;

    const dialogRef = this.dialog.open(ModalGestionesComponent, {
      width: '95%', // Ancho del diálogo
      height: '90%', // Alto del diálogo
      disableClose: true,
      data: {
        gestiones: gestionesFiltradas,
        tipo: tipo,
        usuarioId: this.data.usuarioId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      //console.log(`Dialog result: ${result}`);
    });
  }

  GenerateDataFacturacion(
    event: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>
  ) {
    this.listCostosFactura = [];
    this.VolumenTotalGestiones = 0;

    if (event.length > 0) {
      let sumFacturaOrigen = 0;
      let sumFacturaT1 = 0;
      let sumFacturaFrontera = 0;
      let sumFacturaT2 = 0;
      let sumFacturaDestino = 0;

      let sumGestionesOrigen = 0;
      let sumGestionesT1 = 0;
      let sumGestionesFrontera = 0;
      let sumGestionesT2 = 0;
      let sumGestionesDestino = 0;

      let sumFacTonOrigen = 0;
      let sumFacTonT1 = 0;
      let sumFacTonFrontera = 0;
      let sumFacTonT2 = 0;
      let sumFacTonDestino = 0;

      this.lineGraphDataTons = [];
      this.groupByCategory = [];

      event.forEach((item) => {
        event.forEach((s) => {
          s.CostosFacturacion.forEach((cat) => {
            cat.DetalleFactura.forEach((det) => {
              if (
                det.Categoria == '' ||
                det.Categoria == null ||
                det.Categoria == undefined
              ) {
                det.Categoria = 'Sin Categoria';
              }
            });
          });
        });
      });

      event.forEach((gestion) => {
        if (gestion.Estado.DisplayName !== 'Finalizado') {
          this.VolumenTotalGestiones += 1;
        }
        if (gestion.Segmentacion.Origen?.SitioActual == true) {
          sumFacturaOrigen += parseFloat(
            Enumerable.from(gestion.CostosFacturacion)
              .sum((s) => s.ValorTotalUSD)
              .toFixed(2)
          );
          sumGestionesOrigen +=
            gestion.Estado.DisplayName === 'Finalizado' ? 0 : 1;
          this.GenerateCalculosXSegFactura(gestion, 'Origen');
          this.almacenarGestionEnContador(gestion, 'Origen');
        } else if (
          gestion.Segmentacion.TransitoUno.some(
            (st1) => st1.SegmentoActual == true || st1.SitioActual == true
          )
        ) {
          sumFacturaT1 += parseFloat(
            Enumerable.from(gestion.CostosFacturacion)
              .sum((s) => s.ValorTotalUSD)
              .toFixed(2)
          );
          sumGestionesT1 += gestion.Estado.DisplayName === 'Finalizado' ? 0 : 1;

          this.GenerateCalculosXSegFactura(gestion, 'TransitoUno');
          this.almacenarGestionEnContador(gestion, 'TransitoUno');
        } else if (
          gestion.Segmentacion.Frontera?.some((st1) => st1.SitioActual == true)
        ) {
          sumFacturaFrontera += parseFloat(
            Enumerable.from(gestion.CostosFacturacion)
              .sum((s) => s.ValorTotalUSD)
              .toFixed(2)
          );
          sumGestionesFrontera +=
            gestion.Estado.DisplayName === 'Finalizado' ? 0 : 1;

          this.GenerateCalculosXSegFactura(gestion, 'Frontera');
          this.almacenarGestionEnContador(gestion, 'Frontera');
        } else if (
          gestion.Segmentacion.TransitoDos.some(
            (st1) => st1.SegmentoActual == true || st1.SitioActual == true
          )
        ) {
          sumFacturaT2 += parseFloat(
            Enumerable.from(gestion.CostosFacturacion)
              .sum((s) => s.ValorTotalUSD)
              .toFixed(2)
          );
          sumGestionesT2 += gestion.Estado.DisplayName === 'Finalizado' ? 0 : 1;

          this.GenerateCalculosXSegFactura(gestion, 'TransitoDos');
          this.almacenarGestionEnContador(gestion, 'TransitoDos');
        } else if (
          gestion.Segmentacion.Destino?.some((st1) => st1.SitioActual == true)
        ) {
          sumFacturaDestino += parseFloat(
            Enumerable.from(gestion.CostosFacturacion)
              .sum((s) => s.ValorTotalUSD)
              .toFixed(2)
          );
          sumGestionesDestino +=
            gestion.Estado.DisplayName === 'Finalizado' ? 0 : 1;

          this.GenerateCalculosXSegFactura(gestion, 'Destino');
          this.almacenarGestionEnContador(gestion, 'Destino');
        }

        //Gestiones hijas

        if (
          gestion?.GestionesHijas?.length > 0 &&
          gestion?.Estado?.DisplayName === 'Finalizado'
        ) {
          gestion.GestionesHijas.forEach((gh) => {
            if (gh.Segmentacion.Origen?.SitioActual == true) {
              sumGestionesOrigen += 1;
              this.GenerateCalculosXSegFactura(gh, 'Origen', true);
              this.almacenarGestionEnContador(gh, 'Origen');
            } else if (
              gh.Segmentacion.TransitoUno.some(
                (st1) => st1.SegmentoActual == true || st1.SitioActual == true
              )
            ) {
              sumGestionesT1 += 1;
              this.GenerateCalculosXSegFactura(gh, 'TransitoUno', true);
              this.almacenarGestionEnContador(gh, 'TransitoUno');
            } else if (
              gh.Segmentacion.Frontera?.some((st1) => st1.SitioActual == true)
            ) {
              sumGestionesFrontera += 1;
              this.GenerateCalculosXSegFactura(gh, 'Frontera', true);
              this.almacenarGestionEnContador(gh, 'Frontera');
            } else if (
              gh.Segmentacion.TransitoDos.some(
                (st1) => st1.SegmentoActual == true || st1.SitioActual == true
              )
            ) {
              sumGestionesT2 += 1;
              this.GenerateCalculosXSegFactura(gh, 'TransitoDos', true);
              this.almacenarGestionEnContador(gh, 'TransitoDos');
            } else if (
              gh.Segmentacion.Destino?.some((st1) => st1.SitioActual == true)
            ) {
              sumGestionesDestino += 1;
              this.GenerateCalculosXSegFactura(gh, 'Destino', true);
              this.almacenarGestionEnContador(gh, 'Destino');
            }
          });
          this.VolumenTotalGestiones += gestion.GestionesHijas.length;
        }
      });

      //let USD = Enumerable.from(event).selectMany(s => s.CostosFacturacion).sum(s => s.ValorTotalUSD);
      let USD = parseFloat(
        Enumerable.from(this.groupByCategory)
          .sum((s) => s.USD)
          .toFixed(2)
      );

      this.listCostosFactura.push({
        Expandible: false,
        Volumen: this.VolumenTotalGestiones,
        USD: USD,
        Origen: sumFacturaOrigen,
        TransitoUno: sumFacturaT1,
        Frontera: sumFacturaFrontera,
        TransitoDos: sumFacturaT2,
        Destino: sumFacturaDestino,
        OrigenGestiones: sumGestionesOrigen,
        TransitoUnoGestiones: sumGestionesT1,
        FronteraGestiones: sumGestionesFrontera,
        TransitoDosGestiones: sumGestionesT2,
        DestinoGestiones: sumGestionesDestino,
        ListCategorys: this.groupByCategory,
      });
    } else {
      this.listCostosFactura.push({
        Expandible: false,
        Volumen: event.length,
        USD: 0,
        Origen: 0,
        TransitoUno: 0,
        Frontera: 0,
        TransitoDos: 0,
        Destino: 0,
        OrigenGestiones: 0,
        TransitoUnoGestiones: 0,
        FronteraGestiones: 0,
        TransitoDosGestiones: 0,
        DestinoGestiones: 0,
        ListCategorys: [],
      });
    }
  }

  GenerateCalculosXSegFactura(
    gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
    campoACambiar: string,
    gestionHija = false
  ) {
    let contDetalllesFActuras = 0;
    let campoC = campoACambiar + 'Gestiones';
    if (gestion.CostosFacturacion.length === 0) {
      if (!this.groupByCategory.some((c) => c.Categoria === 'Sin Categoria')) {
        let categoria: CorteDiarioModel.ListCategories = {
          Expandible: false,
          Categoria: 'Sin Categoria',
          USD: 0,
          Origen: 0,
          TransitoUno: 0,
          Frontera: 0,
          TransitoDos: 0,
          Destino: 0,
          OrigenGestiones: 0,
          TransitoUnoGestiones: 0,
          FronteraGestiones: 0,
          TransitoDosGestiones: 0,
          DestinoGestiones: 0,
          Listdos: [],
        };
        if (gestionHija === false) {
          categoria[campoACambiar] = 0; //aqui se acumula el valor al sku
          categoria['USD'] = 0;
        }

        categoria[campoC] =
          gestion.Estado.DisplayName === 'Finalizado' && gestionHija === false
            ? 0
            : 1;

        this.groupByCategory.push(categoria);
      } else {
        //acumular la cantidad en la categoria
        let indexCat = this.groupByCategory.findIndex(
          (s) => s.Categoria == 'Sin Categoria'
        );
        if (gestionHija === false) {
          this.groupByCategory[indexCat][campoACambiar] += 0;
        }
        this.groupByCategory[indexCat][campoC] +=
          contDetalllesFActuras == 0
            ? gestion.Estado.DisplayName === 'Finalizado' &&
              gestionHija === false
              ? 0
              : 1
            : 0; //se acumula una gestion
      }
    } else {
      gestion.CostosFacturacion.forEach((factura) => {
        factura.DetalleFactura.forEach((detalle) => {
          //corroboro si existe la categoria en el array
          if (
            !this.groupByCategory.some((s) => s.Categoria == detalle.Categoria)
          ) {
            //no existe
            //Agregar el sku
            let sku: CorteDiarioModel.ListDosExpandible = {
              Descripcion: detalle.ProductoDescripcion,
              USD: 0,
              Origen: 0,
              TransitoUno: 0,
              Frontera: 0,
              TransitoDos: 0,
              Destino: 0,
              OrigenGestiones: 0,
              TransitoUnoGestiones: 0,
              FronteraGestiones: 0,
              TransitoDosGestiones: 0,
              DestinoGestiones: 0,
            };
            if (gestionHija === false) {
              sku[campoACambiar] = detalle.ValorTotal; //aqui se acumula el valor al sku
              sku['USD'] = detalle.ValorTotal;
            }
            sku[campoC] =
              contDetalllesFActuras == 0
                ? gestion.Estado.DisplayName === 'Finalizado' &&
                  gestionHija === false
                  ? 0
                  : 1
                : 0;

            let categoria: CorteDiarioModel.ListCategories = {
              Expandible: false,
              Categoria: detalle.Categoria,
              USD: 0,
              Origen: 0,
              TransitoUno: 0,
              Frontera: 0,
              TransitoDos: 0,
              Destino: 0,
              OrigenGestiones: 0,
              TransitoUnoGestiones: 0,
              FronteraGestiones: 0,
              TransitoDosGestiones: 0,
              DestinoGestiones: 0,
              Listdos: [sku],
            };
            if (gestionHija === false) {
              categoria[campoACambiar] = detalle.ValorTotal; //aqui se acumula el valor al sku
              categoria['USD'] = detalle.ValorTotal;
            }
            categoria[campoC] =
              contDetalllesFActuras == 0
                ? gestion.Estado.DisplayName === 'Finalizado' &&
                  gestionHija === false
                  ? 0
                  : 1
                : 0;

            this.groupByCategory.push(categoria);
          } else {
            let indexCat = this.groupByCategory.findIndex(
              (s) => s.Categoria == detalle.Categoria
            );
            if (gestionHija === false) {
              this.groupByCategory[indexCat][campoACambiar] +=
                detalle.ValorTotal;
              this.groupByCategory[indexCat].USD += detalle.ValorTotal;
            }
            this.groupByCategory[indexCat][campoC] +=
              contDetalllesFActuras == 0
                ? gestion.Estado.DisplayName === 'Finalizado' &&
                  gestionHija === false
                  ? 0
                  : 1
                : 0; //se acumula una gestion

            //buscar en las lista de  skus si ya existe, sino acumularlo
            if (
              !this.groupByCategory[indexCat].Listdos.some(
                (s) => s.Descripcion == detalle.ProductoDescripcion
              )
            ) {
              //no existe el sku,agregarlo
              let sku = {
                Descripcion: detalle.ProductoDescripcion,
                USD: 0,
                Origen: 0,
                TransitoUno: 0,
                Frontera: 0,
                TransitoDos: 0,
                Destino: 0,
                OrigenGestiones: 0,
                TransitoUnoGestiones: 0,
                FronteraGestiones: 0,
                TransitoDosGestiones: 0,
                DestinoGestiones: 0,
              };
              if (gestionHija === false) {
                sku[campoACambiar] = detalle.ValorTotal;
                sku['USD'] = detalle.ValorTotal;
              }
              sku[campoC] =
                contDetalllesFActuras == 0
                  ? gestion.Estado.DisplayName === 'Finalizado' &&
                    gestionHija === false
                    ? 0
                    : 1
                  : 0;

              this.groupByCategory[indexCat].Listdos.push(sku);
            } else {
              // ya existe el sku
              let indexSku = this.groupByCategory[indexCat].Listdos.findIndex(
                (s) => s.Descripcion == detalle.ProductoDescripcion
              );
              if (indexSku != -1) {
                if (gestionHija === false) {
                  this.groupByCategory[indexCat].Listdos[indexSku][
                    campoACambiar
                  ] += detalle.ValorTotal;
                  this.groupByCategory[indexCat].Listdos[indexSku].USD +=
                    detalle.ValorTotal;
                }
                this.groupByCategory[indexCat].Listdos[indexSku][campoC] +=
                  contDetalllesFActuras == 0
                    ? gestion.Estado.DisplayName === 'Finalizado' &&
                      gestionHija === false
                      ? 0
                      : 1
                    : 0;
              }
            }
          }
          //acumular la cantidad en la categoria

          //para manejar el num de gestiones a agregar a lac ategoria
          contDetalllesFActuras += 1;
        });
      });
    }
  }

  GenerateDataCLogisticos(
    event: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>
  ) {
    //COSTOS LOGISTCOS
    this.listCostosLog = [];
    this.groupByCategoryCL = [];

    let sumCostoOrigen = 0;
    let sumCostoT1 = 0;
    let sumCostoFrontera = 0;
    let sumCostoT2 = 0;
    let sumCostoDestino = 0;

    let categories: string[] = ['Category1', 'Category2', 'Category3'];

    event.forEach((item) => {
      event.forEach((s) => {
        s.CostosLogisticos.forEach((cat) => {
          const randomCategory =
            categories[Math.floor(Math.random() * categories.length)];
          if (
            cat.Categoria == '' ||
            cat.Categoria == null ||
            cat.Categoria == undefined
          ) {
            cat.Categoria = 'Sin Categoría';
          }
        });
      });
    });

    event.forEach((gestion) => {
      if (gestion.Segmentacion.Origen?.SitioActual == true) {
        sumCostoOrigen += parseFloat(
          Enumerable.from(gestion.CostosLogisticos)
            .sum((s) => s.ValorNew)
            .toFixed(2)
        );
        this.GenerateCalculosXSegmentoLogisticos(gestion, 'Origen');
      } else if (
        gestion.Segmentacion.TransitoUno.some(
          (st1) => st1.SegmentoActual == true || st1.SitioActual == true
        )
      ) {
        sumCostoT1 += parseFloat(
          Enumerable.from(gestion.CostosLogisticos)
            .sum((s) => s.ValorNew)
            .toFixed(2)
        );
        this.GenerateCalculosXSegmentoLogisticos(gestion, 'TransitoUno');
      } else if (
        gestion.Segmentacion.Frontera?.some((st1) => st1.SitioActual == true)
      ) {
        sumCostoFrontera += parseFloat(
          Enumerable.from(gestion.CostosLogisticos)
            .sum((s) => s.ValorNew)
            .toFixed(2)
        );
        this.GenerateCalculosXSegmentoLogisticos(gestion, 'Frontera');
      } else if (
        gestion.Segmentacion.TransitoDos.some(
          (st1) => st1.SegmentoActual == true || st1.SitioActual == true
        )
      ) {
        sumCostoT2 += parseFloat(
          Enumerable.from(gestion.CostosLogisticos)
            .sum((s) => s.ValorNew)
            .toFixed(2)
        );
        this.GenerateCalculosXSegmentoLogisticos(gestion, 'TransitoDos');
      } else if (
        gestion.Segmentacion.Destino?.some((st1) => st1.SitioActual == true)
      ) {
        sumCostoDestino += parseFloat(
          Enumerable.from(gestion.CostosLogisticos)
            .sum((s) => s.ValorNew)
            .toFixed(2)
        );
        this.GenerateCalculosXSegmentoLogisticos(gestion, 'Destino');
      }
    });

    let volumenCL = parseFloat(event.length.toFixed(2));
    let USDCL = Enumerable.from(event).sum((s) => s.CostoTotal);

    let costosL = Enumerable.from(event)
      .selectMany((s) => s.CostosLogisticos)
      .toArray();
    let sumCostos = parseFloat(
      Enumerable.from(costosL)
        .sum((s) => s.ValorNew)
        .toFixed(2)
    );

    this.listCostosLog.push({
      Volumen: volumenCL,
      USD: parseFloat(sumCostos.toFixed(2)),
      Origen: parseFloat(sumCostoOrigen.toFixed(2)),
      TransitoUno: parseFloat(sumCostoT1.toFixed(2)),
      Frontera: parseFloat(sumCostoFrontera.toFixed(2)),
      TransitoDos: parseFloat(sumCostoT2.toFixed(2)),
      Destino: parseFloat(sumCostoDestino.toFixed(2)),
      ListCategorys: this.groupByCategoryCL,
    });
  }

  GenerateCalculosXSegmentoLogisticos(
    gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
    campoACambiar: string
  ) {
    let campoC = campoACambiar + 'Gestiones';
    gestion.CostosLogisticos.forEach((cLog) => {
      //corroboro si existe la categoria en el array
      if (!this.groupByCategoryCL.some((s) => s.Categoria == cLog.Categoria)) {
        //no existe
        //Agregar el sku
        let itemDos: CorteDiarioModel.ListDosExpandible = {
          Descripcion: cLog.Descripcion,
          USD: 0,
          Origen: 0,
          TransitoUno: 0,
          Frontera: 0,
          TransitoDos: 0,
          Destino: 0,
          OrigenGestiones: 0,
          TransitoUnoGestiones: 0,
          FronteraGestiones: 0,
          TransitoDosGestiones: 0,
          DestinoGestiones: 0,
        };

        itemDos[campoACambiar] = cLog.ValorNew; //aqui se acumula el valor al sku
        itemDos['USD'] = cLog.ValorNew;
        itemDos[campoC] = 1; //aqui se acumula el valor al sku

        let categoria: CorteDiarioModel.ListCategories = {
          Expandible: false,
          Categoria: cLog.Categoria,
          USD: 0,
          Origen: 0,
          TransitoUno: 0,
          Frontera: 0,
          TransitoDos: 0,
          Destino: 0,
          OrigenGestiones: 0,
          TransitoUnoGestiones: 0,
          FronteraGestiones: 0,
          TransitoDosGestiones: 0,
          DestinoGestiones: 0,
          Listdos: [itemDos],
        };

        categoria[campoACambiar] = cLog.ValorNew; //aqui se acumula el valor al sku
        categoria['USD'] = cLog.ValorNew;
        categoria[campoC] = 1; //aqui se acumula el valor de una gestion a la cat

        this.groupByCategoryCL.push(categoria);
      } else {
        //acumular la cantidad en la categoria
        let indexCat = this.groupByCategoryCL.findIndex(
          (s) => s.Categoria == cLog.Categoria
        );
        this.groupByCategoryCL[indexCat][campoACambiar] += cLog.ValorNew;
        this.groupByCategoryCL[indexCat][campoC] += 1; //se acumula una gestion
        this.groupByCategoryCL[indexCat].USD += cLog.ValorNew;
        //buscar en las lista de  skus si ya existe, sino acumularlo
        if (
          !this.groupByCategoryCL[indexCat].Listdos.some(
            (s) => s.Descripcion == cLog.Descripcion
          )
        ) {
          //no existe el sku,agregarlo
          let itemDos = {
            Descripcion: cLog.Descripcion,
            USD: 0,
            Origen: 0,
            TransitoUno: 0,
            Frontera: 0,
            TransitoDos: 0,
            Destino: 0,
            OrigenGestiones: 0,
            TransitoUnoGestiones: 0,
            FronteraGestiones: 0,
            TransitoDosGestiones: 0,
            DestinoGestiones: 0,
          };

          itemDos[campoACambiar] = cLog.ValorNew;
          itemDos['USD'] = cLog.ValorNew;
          itemDos[campoC] += 1; //aqui se acumula el valor al sku

          this.groupByCategoryCL[indexCat].Listdos.push(itemDos);
        } else {
          // ya existe el sku
          let indexSku = this.groupByCategoryCL[indexCat].Listdos.findIndex(
            (s) => s.Descripcion == cLog.Descripcion
          );
          if (indexSku != -1) {
            this.groupByCategoryCL[indexCat].Listdos[indexSku][campoACambiar] +=
              cLog.ValorNew;
            this.groupByCategoryCL[indexCat].Listdos[indexSku][campoC] += 1;
            this.groupByCategoryCL[indexCat].Listdos[indexSku].USD +=
              cLog.ValorNew;
          }
        }
      }
    });
  }

  almacenarGestionEnContador(
    gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
    segmento: string
  ) {
    // Verificar si CostosFacturacion está vacío
    if (gestion.CostosFacturacion.length === 0) {
      // Si no hay CostosFacturacion, se considera como 'Sin Categoria'
      const categoria = 'Sin Categoria';

      // Mapear segmentos a contadores
      const contadores = {
        Origen: this.contadorCategoriasOrigen,
        TransitoUno: this.contadorCategoriasTransitoUno,
        Frontera: this.contadorCategoriasFrontera,
        TransitoDos: this.contadorCategoriasTransitoDos,
        Destino: this.contadorCategoriasDestino,
      };

      const contador = contadores[segmento];
      if (!contador) return;

      // Agregar la gestión al contador bajo 'Sin Categoria'
      if (!contador[categoria]) {
        contador[categoria] = { gestiones: [] };
      }
      contador[categoria].gestiones.push(gestion);
      return; // Salir de la función después de manejar este caso
    }

    // Extraer categorías y reemplazar valores no válidos con 'Sin Categoria'
    const categorias = [
      ...new Set(
        gestion.CostosFacturacion.flatMap((factura) =>
          factura.DetalleFactura.map(
            (detalle) => detalle.Categoria?.trim() || 'Sin Categoria' // Usamos trim() para eliminar espacios en blanco
          )
        )
      ),
    ];

    // Mapear segmentos a contadores
    const contadores = {
      Origen: this.contadorCategoriasOrigen,
      TransitoUno: this.contadorCategoriasTransitoUno,
      Frontera: this.contadorCategoriasFrontera,
      TransitoDos: this.contadorCategoriasTransitoDos,
      Destino: this.contadorCategoriasDestino,
    };

    const contador = contadores[segmento];
    if (!contador) return;

    // Agregar gestiones al contador
    categorias.forEach((categoria) => {
      if (!contador[categoria]) {
        contador[categoria] = { gestiones: [] };
      }
      contador[categoria].gestiones.push(gestion);
    });
  }

  // Método para activar filtro
  public activarFiltro(filtro: string): void {
    // Colapsar TODAS las listas antes de cambiar el filtro
    this.colapsarTodasLasListas();

    this.filtroActivo = filtro;
  }

  // Nuevo método para colapsar todas las listas
  private colapsarTodasLasListas(): void {
    // Colapsar categorías de facturación
    if (this.listCostosFactura) {
      this.listCostosFactura.forEach((item) => {
        if (item.ListCategorys) {
          item.ListCategorys.forEach((categoria) => {
            categoria.Expandible = false;
          });
        }
      });
    }
  }

  // Método para validar si un filtro está activo
  public esFiltroActivo(filtro: string): boolean {
    return this.filtroActivo === filtro;
  }

  eventModalGestionesCategoriasFiltros(
    TipoSegmentacion: string,
    categoria: string
  ) {
    // Seleccionar el contador según el TipoSegmentacion
    let contador: {
      [key: string]: {
        gestiones: CorteDiarioModel.GetGestionesAbiertasXRutas[];
      };
    };

    switch (TipoSegmentacion) {
      case 'Origen':
        contador = this.contadorCategoriasOrigen;
        break;
      case 'TransitoUno':
        contador = this.contadorCategoriasTransitoUno;
        break;
      case 'Frontera':
        contador = this.contadorCategoriasFrontera;
        break;
      case 'TransitoDos':
        contador = this.contadorCategoriasTransitoDos;
        break;
      case 'Destino':
        contador = this.contadorCategoriasDestino;
        break;
      default:
        console.error('Tipo de segmentación no válido:', TipoSegmentacion);
        return;
    }

    // Obtener las gestiones del contador para la categoría seleccionada
    const gestionesContador = contador[categoria]?.gestiones || [];
    console.log('Gestiones en el contador:', gestionesContador);

    // Buscar las gestiones completas en this.listGestiones y en las GestionesHijas
    const gestionesCompletas: CorteDiarioModel.GetGestionesAbiertasXRutas[] =
      [];

    gestionesContador.forEach((gestionContador) => {
      // Buscar en las gestiones principales
      const gestionPrincipal = this.listGestiones.find(
        (g) => g.NumeroGestion === gestionContador.NumeroGestion
      );

      if (gestionPrincipal) {
        gestionesCompletas.push(gestionPrincipal);
      }

      // Buscar en las GestionesHijas de cada gestión principal
      this.listGestiones.forEach((gestion) => {
        if (gestion.GestionesHijas && gestion.GestionesHijas.length > 0) {
          const gestionHija = gestion.GestionesHijas.find(
            (gh) => gh.NumeroGestion === gestionContador.NumeroGestion
          );

          if (gestionHija) {
            gestionesCompletas.push(gestionHija);
          }
        }
      });
    });

    // Abrir el modal y pasar las gestiones completas
    const dialogRef = this.dialog.open(ModalGestionesGenericoComponent, {
      width: '95%', // Ancho del diálogo
      height: '90%', // Alto del diálogo
      disableClose: true,
      data: {
        TipoSegmentacion: TipoSegmentacion,
        usuarioId: this.data.usuarioId,
        gestiones: gestionesCompletas, // Pasar las gestiones completas
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Lógica después de cerrar el modal (si es necesario)
    });
  }

  eventModalGestionesDestinoFiltros(
    TipoSegmentacion: string,
    TipoLista: string,
    sitio: CorteDiarioModel.NombresXRutasXSegmentacion
  ) {
    // Obtener el nombre del sitio
    const nombreSitio = sitio.NombreRuta;

    // Variable para almacenar las gestiones filtradas del contador seleccionado
    let gestionesContador: CorteDiarioModel.GetGestionesAbiertasXRutas[] = [];

    // Seleccionar el contador según el TipoSegmentacion
    if (TipoSegmentacion === 'Origen') {
      gestionesContador = this.contadorDestinoOrigen[nombreSitio] || [];
    } else if (TipoSegmentacion === 'TransitoUno') {
      gestionesContador = this.contadorDestinoTransitoUno[nombreSitio] || [];
    } else if (TipoSegmentacion === 'Frontera') {
      gestionesContador = this.contadorDestinoFrontera[nombreSitio] || [];
    } else if (TipoSegmentacion === 'TransitoDos') {
      gestionesContador = this.contadorDestinoTransitoDos[nombreSitio] || [];
    } else if (TipoSegmentacion === 'Destino') {
      gestionesContador = this.contadorDestinoDestino[nombreSitio] || [];
    }

    // Buscar las gestiones completas en this.listGestiones y en las GestionesHijas
    let gestionesCompletas: CorteDiarioModel.GetGestionesAbiertasXRutas[] = [];

    gestionesContador.forEach((gestionContador) => {
      // Buscar en las gestiones principales
      const gestionPrincipal = this.listGestiones.find(
        (g) => g.NumeroGestion === gestionContador.NumeroGestion
      );

      if (gestionPrincipal) {
        gestionesCompletas.push(gestionPrincipal);
      }

      // Buscar en las GestionesHijas de cada gestión principal
      this.listGestiones.forEach((gestion) => {
        if (gestion.GestionesHijas && gestion.GestionesHijas.length > 0) {
          const gestionHija = gestion.GestionesHijas.find(
            (gh) => gh.NumeroGestion === gestionContador.NumeroGestion
          );

          if (gestionHija) {
            gestionesCompletas.push(gestionHija);
          }
        }
      });
    });

    // Abrir el modal y pasar las gestiones completas
    const dialogRef = this.dialog.open(ModalGestionesGenericoComponent, {
      width: '95%', // Ancho del diálogo
      height: '90%', // Alto del diálogo
      disableClose: true,
      data: {
        TipoSegmentacion: TipoSegmentacion,
        usuarioId: this.data.usuarioId,
        gestiones: gestionesCompletas, // Pasar las gestiones completas
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Lógica después de cerrar el modal (si es necesario)
    });
  }

  eventModalGestionesOrigenFiltros(
    TipoSegmentacion: string,
    TipoLista: string,
    sitio: CorteDiarioModel.NombresXRutasXSegmentacion
  ) {
    // Obtener el nombre del sitio
    const nombreSitio = sitio.NombreRuta;

    // Variable para almacenar las gestiones filtradas del contador seleccionado
    let gestionesContador: CorteDiarioModel.GetGestionesAbiertasXRutas[] = [];

    // Seleccionar el contador según el TipoSegmentacion
    switch (TipoSegmentacion) {
      case 'Origen':
        gestionesContador = this.contadorOrigenOrigen[nombreSitio] || [];
        break;
      case 'TransitoUno':
        gestionesContador = this.contadorOrigenTransitoUno[nombreSitio] || [];
        break;
      case 'Frontera':
        gestionesContador = this.contadorOrigenFrontera[nombreSitio] || [];
        break;
      case 'TransitoDos':
        gestionesContador = this.contadorOrigenTransitoDos[nombreSitio] || [];
        break;
      case 'Destino':
        gestionesContador = this.contadorOrigenDestino[nombreSitio] || [];
        break;
    }

    // Agrupar las gestiones en listGestiones por NumeroGestion
    const gestionesAgrupadas = this.listGestiones.reduce((acc, gestion) => {
      if (!acc[gestion.NumeroGestion]) {
        acc[gestion.NumeroGestion] = [];
      }
      acc[gestion.NumeroGestion].push(gestion);
      return acc;
    }, {} as { [key: string]: CorteDiarioModel.GetGestionesAbiertasXRutas[] });

    // Buscar las gestiones completas en this.listGestiones usando el NumeroGestion
    let gestionesCompletas: CorteDiarioModel.GetGestionesAbiertasXRutas[] = [];

    gestionesContador.forEach((gestionContador) => {
      const gestionesConMismoNumero =
        gestionesAgrupadas[gestionContador.NumeroGestion] || [];

      // Verificar si alguna de las gestiones con el mismo NumeroGestion tiene gestiones hijas que coincidan
      const gestionValida = gestionesConMismoNumero.find((gestion) => {
        // Si la gestión tiene gestiones hijas, compararlas con las gestiones hijas de gestionContador
        if (
          gestionContador.GestionesHijas &&
          gestionContador.GestionesHijas.length > 0
        ) {
          return gestionContador.GestionesHijas.every((hija) =>
            gestion.GestionesHijas.some(
              (gestionHija) => gestionHija.NumeroGestion === hija.NumeroGestion
            )
          );
        }

        // Si no hay gestiones hijas, tomar la gestión actual
        return true;
      });

      // Si se encontró una gestión válida, agregarla a gestionesCompletas
      if (gestionValida) {
        gestionesCompletas.push(gestionValida);
      }
    });

    gestionesCompletas = gestionesCompletas.filter(
      (gestion, index, self) =>
        index ===
        self.findIndex((g) => g.NumeroGestion === gestion.NumeroGestion)
    );

    // Abrir el modal y pasar las gestiones completas
    const dialogRef = this.dialog.open(ModalGestionesGenericoComponent, {
      width: '95%', // Ancho del diálogo
      height: '90%', // Alto del diálogo
      disableClose: true,
      data: {
        TipoSegmentacion: TipoSegmentacion,
        usuarioId: this.data.usuarioId,
        gestiones: gestionesCompletas, // Pasar las gestiones completas
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Lógica después de cerrar el modal (si es necesario)
    });
  }

  GenerateDataOrigenFiltro(
    gestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>
  ) {
    // Crear una copia temporal de las gestiones para no modificar las originales
    let temporalGestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas> =
      [...gestiones];

    // Limpiar la lista de orígenes antes de llenarla
    this.listOrigen = [];
    this.contadorOrigenOrigen = {};
    this.contadorOrigenTransitoUno = {};
    this.contadorOrigenFrontera = {};
    this.contadorOrigenTransitoDos = {};
    this.contadorOrigenDestino = {};

    if (temporalGestiones.length > 0) {
      const procesarGestion = (
        gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
        gestionMadre: CorteDiarioModel.GetGestionesAbiertasXRutas // Nueva variable para guardar la madre
      ) => {
        // Usar el nombre del sitio de la gestión madre, incluso si es una hija
        const nombreSitio = gestionMadre.OrigenNombre;

        if (nombreSitio) {
          // Verificar si el sitio ya existe
          const sitioExiste = this.listOrigen.some(
            (s) => s.NombreRuta === nombreSitio
          );

          // Contabilizar segmentos del origen
          this.contabilizarSegmentos(
            gestion,
            nombreSitio,
            sitioExiste,
            gestionMadre
          ); // Pasamos la gestión madre
        }
      };

      // Procesar las gestiones
      temporalGestiones.forEach((gestion) => {
        if (
          gestion.Estado.DisplayName === 'Finalizado' &&
          gestion.GestionesHijas.length > 0
        ) {
          // Procesar las gestiones hijas, pero usar el nombre del sitio de la gestión madre
          gestion.GestionesHijas.forEach((gestionHija) => {
            procesarGestion(gestionHija, gestion); // Pasamos la gestión madre como segundo parámetro
          });
        } else {
          // Si no tiene gestiones hijas, procesar la gestión actual como madre
          procesarGestion(gestion, gestion);
        }
      });
    }
  }

  contabilizarSegmentos(
    gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
    nombreSitio: string,
    sitioExiste: boolean,
    gestionMadre: CorteDiarioModel.GetGestionesAbiertasXRutas // Nueva variable para guardar la madre
  ): void {
    let origen = 0;
    let transitoUno = 0;
    let frontera = 0;
    let transitoDos = 0;
    let destino = 0;

    // Contabilizar según la segmentación
    if (gestion?.Segmentacion?.Origen?.SitioActual === true) {
      origen += 1;
      if (!this.contadorOrigenOrigen[nombreSitio]) {
        this.contadorOrigenOrigen[nombreSitio] = [];
      }
      this.contadorOrigenOrigen[nombreSitio].push(gestionMadre); // Guardar la gestión madre
    } else if (
      gestion?.Segmentacion?.TransitoUno?.some(
        (s) => s.SitioActual === true || s.SegmentoActual === true
      )
    ) {
      transitoUno += 1;
      if (!this.contadorOrigenTransitoUno[nombreSitio]) {
        this.contadorOrigenTransitoUno[nombreSitio] = [];
      }
      this.contadorOrigenTransitoUno[nombreSitio].push(gestionMadre); // Guardar la gestión madre
    } else if (
      gestion?.Segmentacion?.Frontera?.some((s) => s.SitioActual === true)
    ) {
      frontera += 1;
      if (!this.contadorOrigenFrontera[nombreSitio]) {
        this.contadorOrigenFrontera[nombreSitio] = [];
      }
      this.contadorOrigenFrontera[nombreSitio].push(gestionMadre); // Guardar la gestión madre
    } else if (
      gestion?.Segmentacion?.TransitoDos?.some(
        (s) => s.SitioActual === true || s.SegmentoActual === true
      )
    ) {
      transitoDos += 1;
      if (!this.contadorOrigenTransitoDos[nombreSitio]) {
        this.contadorOrigenTransitoDos[nombreSitio] = [];
      }
      this.contadorOrigenTransitoDos[nombreSitio].push(gestionMadre); // Guardar la gestión madre
    } else if (
      gestion?.Segmentacion?.Destino?.some((s) => s.SitioActual === true)
    ) {
      destino += 1;
      if (!this.contadorOrigenDestino[nombreSitio]) {
        this.contadorOrigenDestino[nombreSitio] = [];
      }
      this.contadorOrigenDestino[nombreSitio].push(gestionMadre); // Guardar la gestión madre
    }

    if (!sitioExiste) {
      // Crear el sitio si no existe
      this.listOrigen.push({
        NombreRuta: nombreSitio,
        Origen: origen,
        TransitoUno: transitoUno,
        Frontera: frontera,
        TransitoDos: transitoDos,
        Destino: destino,
        NumeroGestion: gestionMadre.NumeroGestion, // Usar el número de gestión de la madre
      });
    } else {
      // Acumular en el sitio existente
      const sitio = this.listOrigen.find((s) => s.NombreRuta === nombreSitio);
      if (sitio) {
        sitio.Origen += origen;
        sitio.TransitoUno += transitoUno;
        sitio.Frontera += frontera;
        sitio.TransitoDos += transitoDos;
        sitio.Destino += destino;
      }
    }
  }

  GenerateDataDestinoFiltro(
    gestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>
  ) {
    // Limpiar la lista de destinos antes de llenarla
    this.listDestino = [];
    this.contadorDestinoOrigen = {};
    this.contadorDestinoTransitoUno = {};
    this.contadorDestinoFrontera = {};
    this.contadorDestinoTransitoDos = {};
    this.contadorDestinoDestino = {};

    if (gestiones.length > 0) {
      const procesarGestion = (
        gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
        nombreSitio: string // Ahora el nombre del sitio se pasa como parámetro
      ) => {
        if (nombreSitio) {
          // Verificar si el sitio ya existe
          const sitioExiste = this.listDestino.some(
            (s) => s.NombreRuta === nombreSitio
          );

          // Contabilizar segmentos del destino
          this.contabilizarSegmentosDestino(gestion, nombreSitio, sitioExiste);
        }
      };

      // Procesar las gestiones principales y sus hijas
      gestiones.forEach((gestion) => {
        const gestionesHijas = gestion.GestionesHijas || [];

        if (
          gestion.Estado.DisplayName === 'Finalizado' &&
          gestionesHijas.length > 0
        ) {
          // Si la gestión está finalizada y tiene hijas, procesar solo las hijas
          gestionesHijas.forEach((hija) => {
            procesarGestion(hija, hija.DestinoNombre); // Tomar el destino de la hija
          });
        } else {
          // Si la gestión no está finalizada, procesar la gestión principal
          let nombreSitio = gestion.DestinoNombre;

          // Si tiene hijas, tomar el destino de las hijas (aunque se procese la madre)
          if (gestionesHijas.length > 0) {
            // Tomar el destino de la primera hija
            nombreSitio =
              gestionesHijas[0].DestinoNombre || gestion.DestinoNombre;
          }

          procesarGestion(gestion, nombreSitio); // Procesar la madre con el destino correcto
        }
      });
    }
  }

  contabilizarSegmentosDestino(
    gestion: CorteDiarioModel.GetGestionesAbiertasXRutas,
    nombreSitio: string,
    sitioExiste: boolean
  ): void {
    let origen = 0;
    let transitoUno = 0;
    let frontera = 0;
    let transitoDos = 0;
    let destino = 0;

    // Contabilizar según la segmentación
    if (gestion?.Segmentacion?.Origen?.SitioActual === true) {
      origen += 1;
      if (!this.contadorDestinoOrigen[nombreSitio]) {
        this.contadorDestinoOrigen[nombreSitio] = [];
      }
      this.contadorDestinoOrigen[nombreSitio].push(gestion);
    } else if (
      gestion?.Segmentacion?.TransitoUno?.some(
        (s) => s.SitioActual === true || s.SegmentoActual === true
      )
    ) {
      transitoUno += 1;
      if (!this.contadorDestinoTransitoUno[nombreSitio]) {
        this.contadorDestinoTransitoUno[nombreSitio] = [];
      }
      this.contadorDestinoTransitoUno[nombreSitio].push(gestion);
    } else if (
      gestion?.Segmentacion?.Frontera?.some((s) => s.SitioActual === true)
    ) {
      frontera += 1;
      if (!this.contadorDestinoFrontera[nombreSitio]) {
        this.contadorDestinoFrontera[nombreSitio] = [];
      }
      this.contadorDestinoFrontera[nombreSitio].push(gestion);
    } else if (
      gestion?.Segmentacion?.TransitoDos?.some(
        (s) => s.SitioActual === true || s.SegmentoActual === true
      )
    ) {
      transitoDos += 1;
      if (!this.contadorDestinoTransitoDos[nombreSitio]) {
        this.contadorDestinoTransitoDos[nombreSitio] = [];
      }
      this.contadorDestinoTransitoDos[nombreSitio].push(gestion);
    } else if (
      gestion?.Segmentacion?.Destino?.some((s) => s.SitioActual === true)
    ) {
      destino += 1;
      if (!this.contadorDestinoDestino[nombreSitio]) {
        this.contadorDestinoDestino[nombreSitio] = [];
      }
      this.contadorDestinoDestino[nombreSitio].push(gestion);
    }

    if (!sitioExiste) {
      // Crear el sitio si no existe
      this.listDestino.push({
        NombreRuta: nombreSitio,
        Origen: origen,
        TransitoUno: transitoUno,
        Frontera: frontera,
        TransitoDos: transitoDos,
        Destino: destino,
        NumeroGestion: gestion.NumeroGestion,
      });
    } else {
      // Acumular en el sitio existente
      const sitio = this.listDestino.find((s) => s.NombreRuta === nombreSitio);
      if (sitio) {
        sitio.Origen += origen;
        sitio.TransitoUno += transitoUno;
        sitio.Frontera += frontera;
        sitio.TransitoDos += transitoDos;
        sitio.Destino += destino;
      }
    }
  }
}
